import { FetchDefaultOptions } from './fetch-default-options';
import { request } from './request';

export interface RequestConfiguration {
  params: { [key: string]: any };
}

export class ApiService {
  public static get(url: string, configuration?: RequestConfiguration): Promise<Response> {
    let encodedURL = url;

    if (configuration) {
      const encodedParams = Object.keys(configuration.params).reduce((uriComponents: string[], param: string) => {
        const keyValuePair = `${param}=${encodeURIComponent(configuration.params[param])}`;
        if (configuration.params[param]) {
          uriComponents.push(keyValuePair);
        }

        return uriComponents;
      }, []);

      encodedURL = url.concat('?', encodedParams.join('&'));
    }

    return request(encodedURL, FetchDefaultOptions.forGet());
  }

  public static post(url: string, body: any, configuration?: RequestConfiguration): Promise<Response> {
    let encodedURL = url;

    if (configuration) {
      const encodedParams = Object.keys(configuration.params).reduce((uriComponents: string[], param: string) => {
        const keyValuePair = `${param}=${encodeURIComponent(configuration.params[param])}`;
        if (configuration.params[param]) {
          uriComponents.push(keyValuePair);
        }

        return uriComponents;
      }, []);

      encodedURL = url.concat('?', encodedParams.join('&'));
    }
    return request(encodedURL, FetchDefaultOptions.forPost(body));
  }

  public static put(url: string, body?: any): Promise<Response> {
    return request(url, FetchDefaultOptions.forPut(body));
  }

  public static patch(url: string, body: any): Promise<Response> {
    return request(url, FetchDefaultOptions.forPatch(body));
  }

  public static delete(url: string): Promise<Response> {
    return request(url, FetchDefaultOptions.forDelete());
  }
}
